import React, { useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { ArrowLeft, Save } from "react-feather";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import { FormProvider, useForm } from "react-hook-form";
import { format } from "date-fns";
import { yupResolver } from "@hookform/resolvers/yup";
import Error404 from "MainPages/ErrorPages/error404";
import { all_routes } from "Router/all_routes";
import { Link, useNavigate } from "react-router-dom";
import { bankValidationSchema } from "core/Operations/ValidationSchema/MasterValidationSchema";

import { toast } from "core/Operations/toast";
import BankForm from "Components/Form/BankForm";
import { useInsertBankMutation } from "AppQuries/master/Bank/bank";
import { BackIcon } from "Components/UI/Icon/Icons";
const AddBank = () => {
  const userData = useSelector(loggedInUser);
  const {
    mutate: addBank,
    isPending,
    isError,
    error,
  } = useInsertBankMutation();
  const methods = useForm({
    defaultValues: {
      companyCode: userData.companyCode,
      id: 0,
      bankCode: "",
      bankShortCode: "",
      accountNumber: "",
      organisationId: "",
      companyUEN: "",
      bankName: "",
      swiftCode: "",
      createUser: userData.userName,
      createDate: `${format(new Date(), "yyyy-MM-dd")}T${format(
        new Date(),
        "HH:mm:ss.SSS",
      )}Z`,
      modifyUser: userData.userName,
      modifyDate: `${format(new Date(), "yyyy-MM-dd")}T${format(
        new Date(),
        "HH:mm:ss.SSS",
      )}Z`,
      isActive: true,
    },
    resolver: yupResolver(bankValidationSchema),
  });

  const navigate = useNavigate();

  const {
    handleSubmit,
    formState: { errors },
  } = methods;

  const onSubmit = (payload) => {
    console.log(payload);
    addBank(payload, {
      onSuccess: (data) => {
        console.log(data);
        if (data === true) {
          toast.success("Bank Added Successfully.");

          // setTimeout(() => {
          navigate(`${all_routes.master}${all_routes.bank}`);
          // }, 1000);
        } else {
          toast.warning(data?.[0]?.errorMessage || "Something went wrong.");
        }
      },
      onError: (error) => {
        toast.error(error.message || "Something went wrong.");
      },
    });
  };
  if (isError) return <Error404 error={error} />;
  return (
    <div className="page-wrapper">
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="content">
            <div className="page-header">
              <div className="add-item d-flex">
                <div className="page-title">
                  <h4>Add Bank Master</h4>
                  <h6>Add your new Bank Master </h6>
                </div>
              </div>

              <div className="page-btn" style={{ display: "flex" }}>
                
                
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip id="add-new-tooltip">Save Bank</Tooltip>}
                >
                  <button type="submit" className="btn btn-added">
                    <Save className="me-2" />
                    Save
                  </button>
                </OverlayTrigger>
                &nbsp;
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip id="add-new-tooltip">Back</Tooltip>}
                >
                  <Link
                    to={`${all_routes.master}${all_routes.bank}`}
                    className="btn btn-secondary"
                  >
                    <BackIcon className="me-2" />
                    Back
                  </Link>
                </OverlayTrigger>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card border-0">
                  <div className="card-body">
                    <BankForm />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </FormProvider>
    </div>
  );
};

export default AddBank;
